<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" id="_idContainer004" role="doc-toc">
<p class="TOCtitle">Contents</p>
<p class="TOCitem"><a href="#/Prologue#_idTextAnchor000">Prologue</a></p>
<p class="TOCitem"><a href="#/Chapter_One#_idTextAnchor001">Chapter One</a></p>
<p class="TOCitem"><a href="#/Chapter_Two#_idTextAnchor002">Chapter Two</a></p>
<p class="TOCitem"><a href="#/Chapter_Three#_idTextAnchor003">Chapter Three</a></p>
<p class="TOCitem"><span href="#/Chapter_Four#_idTextAnchor004" title="Link target outside of Sample">Chapter Four</span></p>
<p class="TOCitem"><span href="#/Chapter_Five#_idTextAnchor005" title="Link target outside of Sample">Chapter Five</span></p>
<p class="TOCitem"><span href="#/Chapter_Six#_idTextAnchor006" title="Link target outside of Sample">Chapter Six</span></p>
<p class="TOCitem"><span href="#/Chapter_Seven#_idTextAnchor007" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="TOCitem"><span href="#/Chapter_Eight#_idTextAnchor008" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="TOCitem"><span href="#/Chapter_Nine#_idTextAnchor009" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="TOCitem"><span href="#/Chapter_Ten#_idTextAnchor010" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="TOCitem"><span href="#/Chapter_Eleven#_idTextAnchor011" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="TOCitem"><span href="#/Chapter_Twelve#_idTextAnchor012" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="TOCitem"><span href="#/Chapter_Thirteen#_idTextAnchor013" title="Link target outside of Sample">Chapter Thirteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Fourteen#_idTextAnchor014" title="Link target outside of Sample">Chapter Fourteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Fifteen#_idTextAnchor015" title="Link target outside of Sample">Chapter Fifteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Sixteen#_idTextAnchor016" title="Link target outside of Sample">Chapter Sixteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Seventeen#_idTextAnchor017" title="Link target outside of Sample">Chapter Seventeen</span></p>
<p class="TOCitem"><span href="#/Chapter_Eighteen#_idTextAnchor018" title="Link target outside of Sample">Chapter Eighteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Nineteen#_idTextAnchor019" title="Link target outside of Sample">Chapter Nineteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Twenty#_idTextAnchor020" title="Link target outside of Sample">Chapter Twenty</span></p>
<p class="TOCitem"><a href="#/Chapter_Twentyone#_idTextAnchor021">Chapter Twenty-One</a></p>
<p class="TOCitem"><a href="#/Chapter_Twentytwo#_idTextAnchor022">Chapter Twenty-Two</a></p>
<p class="TOCitem"><a href="#/Chapter_Twentythree#_idTextAnchor023">Chapter Twenty-Three</a></p>
<p class="TOCitem"><a href="#/Chapter_Twentyfour#_idTextAnchor024">Chapter Twenty-Four</a></p>
<p class="TOCitem"><a href="#/Chapter_Twentyfive#_idTextAnchor025">Chapter Twenty-Five</a></p>
<p class="TOCitem"><a href="#/Chapter_Twentysix#_idTextAnchor026">Chapter Twenty-Six</a></p>
<p class="TOCitem"><a href="#/Chapter_Twentyseven#_idTextAnchor027">Chapter Twenty-Seven</a></p>
<p class="TOCitem"><a href="#/Chapter_Twentyeight#_idTextAnchor028">Chapter Twenty-Eight</a></p>
<p class="TOCitem"><a href="#/Chapter_Twentynine#_idTextAnchor029">Chapter Twenty-Nine</a></p>
<p class="TOCitem"><span href="#/Chapter_Thirty#_idTextAnchor030" title="Link target outside of Sample">Chapter Thirty</span></p>
<p class="TOCitem"><a href="#/Chapter_Thirtyone#_idTextAnchor031">Chapter Thirty-One</a></p>
<p class="TOCitem"><a href="#/Chapter_Thirtytwo#_idTextAnchor032">Chapter Thirty-Two</a></p>
<p class="TOCitem"><a href="#/Chapter_Thirtythree#_idTextAnchor033">Chapter Thirty-Three</a></p>
<p class="TOCitem"><a href="#/Chapter_Thirtyfour#_idTextAnchor034">Chapter Thirty-Four</a></p>
<p class="TOCitem"><a href="#/Chapter_Thirtyfive#_idTextAnchor035">Chapter Thirty-Five</a></p>
<p class="TOCitem"><a href="#/Chapter_Thirtysix#_idTextAnchor036">Chapter Thirty-Six</a></p>
<p class="TOCitem"><a href="#/Chapter_Thirtyseven#_idTextAnchor037">Chapter Thirty-Seven</a></p>
<p class="TOCitem"><a href="#/Chapter_Thirtyeight#_idTextAnchor038">Chapter Thirty-Eight</a></p>
<p class="TOCitem"><a href="#/Chapter_Thirtynine#_idTextAnchor039">Chapter Thirty-Nine</a></p>
<p class="TOCitem"><span href="#/Chapter_Forty#_idTextAnchor040" title="Link target outside of Sample">Chapter Forty</span></p>
<p class="TOCitem"><a href="#/Chapter_Fortyone#_idTextAnchor041">Chapter Forty-One</a></p>
<p class="TOCitem"><a href="#/Chapter_Fortytwo#_idTextAnchor042">Chapter Forty-Two</a></p>
<p class="TOCitem"><a href="#/Chapter_Fortythree#_idTextAnchor043">Chapter Forty-Three</a></p>
<p class="TOCitem"><a href="#/Chapter_Fortyfour#_idTextAnchor044">Chapter Forty-Four</a></p>
<p class="TOCitem"><a href="#/Chapter_Fortyfive#_idTextAnchor045">Chapter Forty-Five</a></p>
<p class="TOCitem"><a href="#/Chapter_Fortysix#_idTextAnchor046">Chapter Forty-Six</a></p>
<p class="TOCitem"><a href="#/Chapter_Fortyseven#_idTextAnchor047">Chapter Forty-Seven</a></p>
<p class="TOCitem"><a href="#/Chapter_Fortyeight#_idTextAnchor048">Chapter Forty-Eight</a></p>
<p class="TOCitem"><a href="#/Chapter_Fortynine#_idTextAnchor049">Chapter Forty-Nine</a></p>
<p class="TOCitem"><span href="#/Chapter_Fifty#_idTextAnchor050" title="Link target outside of Sample">Chapter Fifty</span></p>
<p class="TOCitem"><span href="#/Epilogue#_idTextAnchor051" title="Link target outside of Sample">Epilogue</span></p>
<p class="TOCitem"><span href="#/Excerpt#_idTextAnchor052" title="Link target outside of Sample">Excerpt from <i>Lady Olivia’s Forbidden Protector</i> by Christine Merrill</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?56206a5a